import { useEffect } from "react";
import cn from "classnames";
import { isXsScreen } from "@/utils/screen-size-check";

interface RoundAnnouncementProps {
  round: number;
  className?: string;
  onComplete?: () => void;
}

export const RoundAnnouncement = ({
  round,
  className,
  onComplete,
}: RoundAnnouncementProps) => {
  useEffect(() => {
    // Notify completion after animation time
    const timer = setTimeout(() => {
      if (onComplete) {
        onComplete();
      }
    }, 3500);

    return () => clearTimeout(timer);
  }, [round, onComplete]);

  return (
    <div
      className={cn(
        "flex items-center justify-center pointer-events-none w-full h-full",
        className,
      )}
    >
      <style>
        {`
          @keyframes draw-stroke {
            0% { stroke-dashoffset: 1000; }
            100% { stroke-dashoffset: 0; }
          }
          @keyframes fade-in-fill {
            0% { fill-opacity: 0; }
            100% { fill-opacity: 1; }
          }
          @keyframes scale-pulse {
            0% { transform: scale(0.8); opacity: 0; }
            20% { transform: scale(1); opacity: 1; }
            80% { transform: scale(1); opacity: 1; }
            100% { transform: scale(1.2); opacity: 0; }
          }
          .round-text {
            stroke-dasharray: 1000;
            stroke-dashoffset: 1000;
            animation: 
              draw-stroke 1.5s ease-out forwards,
              fade-in-fill 1s ease-out 1s forwards;
          }
          .announcement-container {
            animation: scale-pulse 3.5s ease-in-out forwards;
          }
        `}
      </style>

      <div key={round} className="announcement-container relative">
        {/* Glow effect behind */}
        <div className="absolute inset-0 bg-yellow-500/20 blur-3xl rounded-full transform scale-150" />

        <svg
          width="600"
          height="200"
          viewBox="0 0 600 200"
          className="overflow-visible"
        >
          <text
            x="50%"
            y="50%"
            dy=".35em"
            textAnchor="middle"
            className="round-text"
            style={{
              fontSize: isXsScreen() ? "40px" : "80px",
              fontFamily: "vck, monospace", // Using project font
              fontWeight: "bold",
              stroke: "#ffffff",
              strokeWidth: "3px",
              fill: "#ffcc00", // Gold fill
              fillOpacity: 0,
              filter: "drop-shadow(0px 4px 10px rgba(0,0,0,0.5))",
            }}
          >
            ROUND {round}
          </text>
        </svg>
      </div>
    </div>
  );
};
